import { useEffect, useState, useRef } from "react";
import { Button, Form, Alert, Row, Col, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import UcrtValidation from "../../../hooks/UcrtValidation";
import { createUpdateUcrt } from "../../../store/actions/ucrtsAction";
import { resetPopup } from "../../../store/reducerSlice/ucrts";
import { fetchLocationList } from "../../../store/actions/locationsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";
import moment from "moment";

const formElements = [
  {
    key: "locationName",
    label: "Geography",
    placeHolder: "Select geography",
    type: "text",
    // options: [],
    // required: true,
  },

  {
    key: "ucrtMse",
    label: "UCRT MSE",
    placeHolder: "Enter UCRT MSE",
    type: "text",
    // required: true,
  },
  {
    key: "workforceCapacity",
    label: "Workforce Capacity",
    placeHolder: "Select workforce capacity",
    type: "select",
    options: ["4", "3", "2", "1"],
  },
  {
    key: "numberOfStaffOnCovidRelatedAbsence",
    label: "No. of staff on COVID related absence?",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "staffingStatus",
    label: "Staffing Status (Planned WTE)",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "bcpService",
    label: "Service in BCP",
    placeHolder: "select",
    type: "select",
    options: ["Yes", "No"],
  },
  {
    key: "caseloadPatients",
    label: "Patients on UCRT caseload (48 hours)",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "virtuWardPatients",
    label: "UCRT Patients identified for Virtual Ward",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "referrals930",
    label: "Referrals to UCRT at 09:30",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "referrals1230",
    label: "Referrals to UCRT at 12:30",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "referrals1630",
    label: "Referrals to UCRT at 16:30",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "duePatients",
    label: "Patients due for discharge",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "carePackages",
    label: "Number of Care Packages (waiting for/coming in)",
    placeHolder: "0",
    type: "text",
  },
  {
    key: "anyChanges",
    label: "Any changes",
    placeHolder: "Enter any changes",
    type: "text",
    size: 8,
  },
  // {
  //   key: "action",
  //   label: "Action Taken",
  //   placeHolder: "Enter any changes",
  //   type: "text",
  //   size: 2,
  // },
  {
    key: "social_care_delays",
    label: "Social Care Delays",
    placeHolder: "0",
    type: "text1",
  },
  {
    key: "staffing_capacity",
    label: "Staffing Capacity",
    placeHolder: "0",
    type: "text1",
  },
  {
    key: "virtual_ward_delays",
    label: "Virtual Ward Delays",
    placeHolder: "0",
    type: "text1",
  },
  {
    key: "Escalations",
    label: "Escalations",
    placeHolder: "0",
    type: "text1",
  },
  {
    key: "BCP",
    label: "BCP",
    placeHolder: "0",
    type: "text1",
  },
];

const ManageUcrt = (props) => {
  const { selectUcrt } = props;
  const adminDetail = props.adminDetail;
  // Accessing wardTypes from adminDetail
  const wardTypes = adminDetail?.wardTypes;
  const locationTypes = adminDetail?.locations;
  const [isShow, setIsShow] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [locationOptions, setLocationOptions] = useState(null);
  const [selectLocation, setSelectedLocation] = useState(null);
  const validateLargeAmount = (event) => {
    const input = event.target.value;
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Allow backspace, delete, and navigation keys
    if (
      (event.key >= "0" && event.key <= "9") ||
      event.key === "Backspace" ||
      event.key === "Delete" ||
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === "Tab"
    ) {
      if (input === "NA") {
        // If the default value is 'NA', clear the text field
        event.target.value = "";
      }
      return;
    } else {
      // Clear the input if a non-numeric value is entered
      event.preventDefault();
      if (input === "NA") {
        // If the default value is 'NA', clear the text field
        event.target.value = "";
      }
    }

    // Check if the input only contains digits
    const isValidFormat = /^\d*$/.test(input + keyValue);

    if (!isValidFormat) {
      event.preventDefault();
    }
  };
  const [ucrtDetail, setUcrtDetail] = useState({
    location: null,
    locationName: null,
    organization: null,
    ucrtMse: null,
    workforceCapacity: null,
    staffingStatus: null,
    numberOfStaffOnCovidRelatedAbsence: null,
    bcpService: null,
    caseloadPatients: null,
    virtuWardPatients: null,
    referrals930: null,
    referrals1230: null,
    referrals1630: null,
    duePatients: null,
    carePackages: null,
    anyChanges: null,
    action: {
      social_care_delays: null,
      staffing_capacity: null,
      virtual_ward_delays: null,
      Escalations: null,
      BCP: null,
    },
  });
  const { locations } = useSelector((state) => {
    return state.locations;
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    UcrtValidation({
      // location: ucrtDetail?.location,
      // name: ucrtDetail?.name ? ucrtDetail?.name : null,
      // type: ucrtDetail?.type,
      // numberOfBeds: ucrtDetail?.numberOfBeds
      //   ? ucrtDetail?.numberOfBeds?.toString()
      //   : null,
    });

  const dispatch = useDispatch();
  const { error: apiError, isLoader } = useSelector((state) => state.ucrts);
  // fetch location list
  useEffect(() => {
    if (!Array.isArray(locations)) {
      dispatch(fetchLocationList());
    }
  }, []);
  // set location list
  useEffect(() => {
    if (Array.isArray(locations)) {
      let arr = locations.map((x) => {
        return { _id: x._id, name: x?.name };
      });
      setLocationOptions(arr);
    }
  }, [locations]);

  // set details page
  useEffect(() => {
    if (selectUcrt === null) {
      setUcrtDetail({
        location: null,
        locationName: null,
        organization: null,
        ucrtMse: null,
        workforceCapacity: null,
        staffingStatus: null,
        numberOfStaffOnCovidRelatedAbsence: null,
        bcpService: null,
        caseloadPatients: null,
        virtuWardPatients: null,
        referrals930: null,
        referrals1230: null,
        referrals1630: null,
        duePatients: null,
        carePackages: null,
        anyChanges: null,
        action: {
          social_care_delays: null,
          staffing_capacity: null,
          virtual_ward_delays: null,
          Escalations: null,
          BCP: null,
        },
      });
    } else {
      setUcrtDetail({
        _id: selectUcrt?._id,
        locationName: selectUcrt?.locationName,
        location: selectUcrt?.locationId,
        organization: selectUcrt?.organization,
        ucrtMse: selectUcrt?.ucrtMse,
        workforceCapacity: selectUcrt?.workforceCapacity,
        staffingStatus: selectUcrt?.staffingStatus,
        numberOfStaffOnCovidRelatedAbsence:
          selectUcrt?.numberOfStaffOnCovidRelatedAbsence,
        bcpService: selectUcrt?.bcpService,
        caseloadPatients: selectUcrt?.caseloadPatients,
        virtuWardPatients: selectUcrt?.virtuWardPatients,
        referrals930:
          selectUcrt?.createdAt &&
          moment(selectUcrt?.createdAt).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD")
            ? selectUcrt?.referrals930 ==="NA" ? '0' : selectUcrt?.referrals930
            : "0",
        referrals1230:
          selectUcrt?.createdAt &&
          moment(selectUcrt?.createdAt).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD")
            ? selectUcrt?.referrals1230 ==="NA" ? '0' : selectUcrt?.referrals1230
            : "0",
        referrals1630:
          selectUcrt?.createdAt &&
          moment(selectUcrt?.createdAt).format("YYYY-MM-DD") ===
            moment().format("YYYY-MM-DD")
            ? selectUcrt?.referrals1630 ==="NA" ? '0' : selectUcrt?.referrals1630
            : "0",
        duePatients: selectUcrt?.duePatients,
        carePackages: selectUcrt?.carePackages,
        anyChanges: selectUcrt?.anyChanges,
        action: {
          social_care_delays: selectUcrt?.action?.social_care_delays
            ? selectUcrt?.action?.social_care_delays
            : "",
          staffing_capacity: selectUcrt?.action?.staffing_capacity
            ? selectUcrt?.action?.staffing_capacity
            : "",
          virtual_ward_delays: selectUcrt?.action?.virtual_ward_delays
            ? selectUcrt?.action?.virtual_ward_delays
            : "",
          Escalations: selectUcrt?.action?.Escalations
            ? selectUcrt?.action?.Escalations
            : "",
          BCP: selectUcrt?.action?.BCP ? selectUcrt?.action?.BCP : "",
        },
      });
    }
  }, [selectUcrt]);
  // Set ward name
  useEffect(() => {
    if (selectUcrt === null) {
      let loc =
        locationOptions &&
        locationOptions.find((opt) => opt._id === ucrtDetail?.location);
      setUcrtDetail({
        ...ucrtDetail,

        ucrtMse:
          (ucrtDetail?.location ? loc?.name : "Geography") +
          " " +
          (ucrtDetail?.type ? ucrtDetail?.type : "UCRT"),
      });
    }
  }, [ucrtDetail?.location, ucrtDetail?.type]);

  const submitHandler = (e) => {
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };
  // formData useEffects
  useEffect(() => {
    setIsUploading(true);
    //const loc =ucrtDetail?.location?JSON.parse(ucrtDetail?.location):null
    let formData = {
      // _id: ucrtDetail?._id,
      location: ucrtDetail?.location,
      // organization: ucrtDetail?.organization,
      ucrtMse: ucrtDetail?.ucrtMse,
      workforceCapacity: ucrtDetail?.workforceCapacity,
      staffingStatus: ucrtDetail?.staffingStatus,
      numberOfStaffOnCovidRelatedAbsence:
        ucrtDetail?.numberOfStaffOnCovidRelatedAbsence,
      bcpService: ucrtDetail?.bcpService,
      caseloadPatients: ucrtDetail?.caseloadPatients,
      virtuWardPatients: ucrtDetail?.virtuWardPatients,
      referrals930: ucrtDetail?.referrals930,
      referrals1230: ucrtDetail?.referrals1230,
      referrals1630: ucrtDetail?.referrals1630,
      duePatients: ucrtDetail?.duePatients,
      carePackages: ucrtDetail?.carePackages,
      anyChanges: ucrtDetail?.anyChanges,
      action: {
        social_care_delays: ucrtDetail?.action?.social_care_delays,
        staffing_capacity: ucrtDetail?.action?.staffing_capacity,
        virtual_ward_delays: ucrtDetail?.action?.virtual_ward_delays,
        Escalations: ucrtDetail?.action?.Escalations,
        BCP: ucrtDetail?.action?.BCP,
      },
    };
    if (!isError() && error !== null && isActionCalled) {
      dispatch(createUpdateUcrt(formData)).then(({ payload }) => {

        if (payload.success) {
          setIsUploading(true);
          hideHandler();
        } else {
          setIsShow(true);
        }
      });
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  useEffect(() => {
    if (apiError) {
      setTimeout(() => {
        dispatch(resetPopup());
      }, 3000);
    }
  }, [apiError]);

  // Set the time to 4:30 PM
  const targetTime930 = moment().set({
    hour: 9,
    minute: 30,
    second: 0,
    millisecond: 0,
  });
  const targetTime1230 = moment().set({
    hour: 12,
    minute: 30,
    second: 0,
    millisecond: 0,
  });
  const targetTime430 = moment().set({
    hour: 16,
    minute: 30,
    second: 0,
    millisecond: 0,
  });
  // Compare the current time with 4:30 PM
  const isBefore930 = moment().isBefore(targetTime930);
  const isBefore1230 = moment().isBefore(targetTime1230);
  const isBefore430 = moment().isBefore(targetTime430);

  const hideHandler = () => {
    setIsActionCalled(false);
    resetAllValidator();
    props.onHide();
    if (selectUcrt === null) {
      setUcrtDetail({
        location: null,
        locationName: null,
        organization: null,
        ucrtMse: null,
        workforceCapacity: null,
        staffingStatus: null,
        numberOfStaffOnCovidRelatedAbsence: null,
        bcpService: null,
        caseloadPatients: null,
        virtuWardPatients: null,
        referrals930: null,
        referrals1230: null,
        referrals1630: null,
        duePatients: null,
        carePackages: null,
        anyChanges: null,
        action: {
          social_care_delays: null,
          staffing_capacity: null,
          virtual_ward_delays: null,
          Escalations: null,
          BCP: null,
        },
      });
    } else {
      setUcrtDetail({
        // _id: selectUcrt._id,
        location: selectUcrt?.location,
        organization: selectUcrt?.organization,
        ucrtMse: selectUcrt?.ucrtMse,
        workforceCapacity: selectUcrt?.workforceCapacity,
        staffingStatus: selectUcrt?.staffingStatus,
        numberOfStaffOnCovidRelatedAbsence:
          selectUcrt?.numberOfStaffOnCovidRelatedAbsence,
        bcpService: selectUcrt?.bcpService,
        caseloadPatients: selectUcrt?.caseloadPatients,
        virtuWardPatients: selectUcrt?.virtuWardPatients,
        referrals930: "",
        referrals1230: "",
        referrals1630: "",
        duePatients: selectUcrt?.duePatients,
        carePackages: selectUcrt?.carePackages,
        anyChanges: selectUcrt?.anyChanges,
        action: {
          social_care_delays: selectUcrt?.action?.social_care_delays,
          staffing_capacity: selectUcrt?.action?.staffing_capacity,
          virtual_ward_delays: selectUcrt?.action?.virtual_ward_delays,
          Escalations: selectUcrt?.action?.Escalations,
          BCP: selectUcrt?.action?.BCP,
        },
      });
    }
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

 
  const { onHide, ...props1 } = props;

  return (
    <>
      <Popup
        {...props1}
        onHide={hideHandler}
        size="xl"
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectUcrt ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}
        {apiError && (
          <Alert variant={"danger"}>
            {apiError?.message || "Access denied! Please try again"}
          </Alert>
        )}

        <Row>
          {formElements.map((element, i) => {
            return (
              (!selectUcrt ||
                element.key !== "password" ||
                element.type !== "text1") && (
                <Col xs={12} md={element.size ? element.size : 4}>
                  <Form.Group
                    className="mb-4"
                    controlId="formBasicEmail"
                    key={i}
                  >
                    {element.type !== "text1" && (
                      <Form.Label>
                        {element.label}{" "}
                        {element.required && (
                          <span className="required">*</span>
                        )}
                      </Form.Label>
                    )}

                    {element.type === "select" ? (
                      <>
                        <Form.Select
                          disabled={
                            element.key === "location" && selectUcrt
                              ? true
                              : false
                          }
                          name={element.key}
                          //value={element.key=='location'? JSON.parse(ucrtDetail?.location) :ucrtDetail[element.key]}
                          value={ucrtDetail[element.key]}
                          onChange={(e) => {
                            setUcrtDetail({
                              ...ucrtDetail,
                              [element.key]: e.target.value,
                            });
                            resetValidator(e.target.name);
                          }}
                          isInvalid={error && error[element.key]}
                        >
                          <option
                            style={{ display: "none", padding: "2px 0px" }}
                            value=""
                          >
                            Select
                          </option>
                          {element.key === "location" && locationTypes
                            ? locationTypes.map((item) => (
                                // <option value={JSON.stringify(item)}>{item.name}</option>
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item._id}
                                >
                                  {item.name}
                                </option>
                              ))
                            : element.key === "location" && locationOptions
                            ? locationOptions.map((item) => (
                                // <option value={JSON.stringify(item)}>{item.name}</option>
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item._id}
                                >
                                  {item.name}
                                </option>
                              ))
                            : element.key === "type" && wardTypes
                            ? wardTypes.map((item) => (
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item}
                                >
                                  {item}
                                </option>
                              ))
                            : element.options.map((item) => (
                                <option
                                  style={{ padding: "2px 0px" }}
                                  value={item}
                                >
                                  {" "}
                                  {item}{" "}
                                </option>
                              ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {error && error[element.key]}
                        </Form.Control.Feedback>
                      </>
                    ) : (
                      element.type !== "text1" && (
                        <>
                          <Form.Control
                            style={{
                              display: element.key ? "display" : "none",
                            }}
                            disabled={
                              element.key === "ucrtMse" ||
                              element.key === "locationName"
                                ? true
                                : false
                            }
                            type={element.type}
                            name={element.key}
                            placeholder={element.placeHolder}
                            value={
                              ucrtDetail && ucrtDetail?.action
                                ? ucrtDetail[element.key] ||
                                  ucrtDetail.action?.[element.key]
                                : ucrtDetail[element.key]
                            }
                            maxLength={element.key === "anyChanges" ? 150 : 10}
                            onChange={(e) => {
                              setUcrtDetail({
                                ...ucrtDetail,
                                [element.key]: e.target.value,
                              });
                            }}
                            onKeyPress={
                              element.key === "anyChanges"
                                ? ""
                                : validateLargeAmount
                            }
                            isInvalid={error && error[element.key]}
                          />
                          <Form.Control.Feedback type="invalid">
                            {error && error[element.key]}
                          </Form.Control.Feedback>
                        </>
                      )
                    )}
                  </Form.Group>
                </Col>
              )
            );
          })}
        </Row>

        <fieldset
          style={{ border: "1px solid", padding: "10px", marginTop: "-40px" }}
        >
          <legend
            style={{
              fontSize: "13px",
              fontWeight: "600",
              float: "none",
              width: "auto",
            }}
          >
            Actions Taken
          </legend>
          <Row>
            {formElements.map((element, i) => {
              return (
                element.type === "text1" && (
                  <Col xs={12} md={element.size ? element.size : 4}>
                    <Form.Group
                      className="mb-4"
                      controlId="formBasicEmail"
                      key={i}
                    >
                      {element.type === "text1" && (
                        <Form.Label>
                          {element.label}{" "}
                          {element.required && (
                            <span className="required">*</span>
                          )}
                        </Form.Label>
                      )}

                      {element.type === "text1" && (
                        <>
                          <Form.Control
                            style={{
                              display: element.key ? "display" : "none",
                            }}
                            disabled={
                              element.key === "ucrtMse" &&
                              element.key === "locationName"
                                ? true
                                : false
                            }
                            type="text"
                            name={element.key}
                            placeholder={element.placeHolder}
                            value={
                              ucrtDetail && ucrtDetail?.action
                                ? ucrtDetail.action[element.key] || ""
                                : ""
                            }
                            // maxLength={element.key === "anyChanges" ? 100 : 3}
                            // onKeyPress={element.key === "anyChanges" ? '' : validateLargeAmount}
                            onChange={(e) => {
                              setUcrtDetail((prevUcrtDetail) => {
                                const updatedUcrtDetail = { ...prevUcrtDetail };

                                // Ensure the action object exists and is an object
                                updatedUcrtDetail.action =
                                  updatedUcrtDetail.action &&
                                  typeof updatedUcrtDetail.action === "object"
                                    ? { ...updatedUcrtDetail.action }
                                    : {};

                                // Update the action object with the new value
                                updatedUcrtDetail.action[element.key] =
                                  e.target.value;

                                return updatedUcrtDetail;
                              });
                            }}
                            isInvalid={error && error[element.key]}
                          />

                          <Form.Control.Feedback type="invalid">
                            {error && error[element.key]}
                          </Form.Control.Feedback>
                        </>
                      )}
                    </Form.Group>
                  </Col>
                )
              );
            })}
          </Row>
        </fieldset>

        {isActionCalled && (
          <ApiResponsePopup
            {...{
              hideHandlerRes,
              isRecordUpdated: isShow,
              title: "Manage UCRT",
              successMsg: successMessage,
              errorRes: apiError?.message,
            }}
          />
        )}
      </Popup>
    </>
  );
};

export default ManageUcrt;
